<template>
	<section class="form-group FormImage" :data-entry="id || name">
		<label v-if="label" class="title" :class="{ required }">{{ label }}</label>
		<label class="image" @click="onClickImage" :class="{ empty: !value }" :style="value ? { '--image': `url(${value})` } : {}">
			<i :class="{ [`icon-${(props && props.icon) || 'image-inverted'}`]: true }"></i>
			<span>(square)</span>
		</label>
		<!-- <input class="input" type="file" :id="id || name" v-bind="$attrs" @change="$emit('change', $event.target.value)" /> -->
		<input type="hidden" :value="value" />
	</section>
</template>

<script>
	import mixin from './mixin';
	import { uploadFile } from '../../libs/file';

	export default {
		mixins: [mixin],

		methods: {
			async onClickImage() {
				const value = await uploadFile();
				if (value) this.$emit('change', value);
			}
		}
	};
</script>

<style scoped lang="scss">
	.FormImage {
		&:not(.disabled) {
			.image {
				cursor: pointer;
			}
		}

		.image {
			display: flex;
			width: 15rem;
			height: 15rem;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			background-color: var(--backgroundColor);
			border-radius: 0.5rem;

			i {
				font-size: 4em;
				color: var(--color);
				transition: opacity 0.2s;
			}

			span {
				opacity: 0.3;
				transition: opacity 0.2s;
			}

			&:not(.empty) {
				background-image: var(--image);
				background-size: cover;
				* {
					opacity: 0;
				}

				&:hover {
					i {
						opacity: 1;
					}

					span {
						opacity: 0.3;
					}
				}
			}
		}

		input {
			display: none;
		}
	}
</style>
